<template>
  <div>
    <div class="header">
      <div class="content">
        <div class="left_menu">
          <img v-if="logo" :src="logo" alt="logo" class="header-logo" />
          <div v-else class="logo_box_bgm"></div>
          <ul class="nav" v-if="siteInfo.navigation">
            <li
              v-for="item in siteInfo.navigation"
              :key="item.name"
              @click.stop="goNext(item)"
              :class="{ active: item.url === menuIndex }"
            >
              <a>{{ item.name }}</a>
              <span class="nav-indicator" v-if="item.url === menuIndex"></span>
            </li>
          </ul>
          <ul class="nav_box_bgm" v-else>
            <li v-for="item in 5" :key="item.name"></li>
          </ul>
        </div>
        <div class="right_area">
          <div class="serch">
            <img class="serch-icon" src="@/assets/search-grey-ico.png" alt="" />
            <input
              class="serch-input"
              type="text"
              placeholder="请输入您要搜索的内容"
              v-model="indexSerch"
              @keyup.enter="indexSerchBtn"
            />
          </div>
          <div
            v-if="userInfo && userInfo != ''"
            class="user-state"
            @mouseover="userOpeShow = true"
            @mouseleave="userOpeShow = false"
          >
            <img
              v-if="userInfo && userInfo.avatar != ''"
              :src="userInfo.avatar"
              class="user-head-portrait"
            />
            <img
              v-else
              :src="require('@/assets/head-default-personal.png')"
              class="user-head-portrait"
            />
            <span class="user-name">{{
              userInfo.nickname || userInfo.phone
            }}</span>
            <ul class="user-list" v-show="userOpeShow">
              <li class="option user-data">
                <router-link to="/userCenter/material">个人中心</router-link>
              </li>
              <li class="option learning-record">
                <router-link to="/userCenter/learning">学习记录</router-link>
              </li>
              <li class="option exit" @click="exitBtn">退出</li>
            </ul>
          </div>
          <div class="user-state" v-else>
            <span class="login-btn" @click="headerLoginBtn">登录</span>
            <span class="login-divider"></span>
            <router-link class="reg-btn" to="/welcomeRegistered">注册</router-link>
          </div>
        </div>
      </div>
    </div>
    <Tip
      :text="tipModal.text"
      :ico="tipModal.ico"
      :showBtns="tipModal.showBtns"
      v-if="tipModal.show"
      :fun="tipModal.fun"
      :confirmFun="tipModal.confirmFun"
      :confirmBtnText="tipModal.confirmBtnText"
      :cancelFun="tipModal.cancelFun"
      :cancelBtnText="tipModal.cancelBtnText"
    />
    <Login v-if="loginModal.show" />

    <div
      class="fixed_right"
      :style="'top:' + rightBoxTop"
      v-if="siteCont && siteCont.waiter_mobile && siteCont.waiter_name"
    >
      <ul>
        <li class="show_more">
          <p class="img">
            <img src="@/assets/mask_box/right_icon1.png" alt="" />
          </p>
          <p class="text">联系我们</p>
          <div class="show_text">
            <div class="title_icon">
              <img src="@/assets/mask_box/right_icon_show.png" alt="" />
              <span>联系我们</span>
            </div>
            <div class="phone_list flex">
              <div class="left_text">
                <div class="num"><span>扫码咨询</span></div>
                <div class="num" v-if="!siteCont.waiter_mobile.includes('|')"><span>联系电话</span>{{siteCont.waiter_mobile}}</div>
                <div class="num num2" v-else>
                  <span>联系电话</span>
                 <div>
                   <p>{{'400-0123-823'}}</p>
                 </div>
                </div>
              </div>
              <div class="code_img">
                <img src="@/assets/mask_box/code_116.png" alt="" />
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Tip from "@/components/pc/tip.vue";
import Login from "@/components/pc/login.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "HeaderWtxh",
  data() {
    return {
      indexSerch: "",
      userOpeShow: false,
      menuIndex: "/index",
      rightBoxTop: "50%",
      siteCont: '',
    };
  },
  props: ["siteInfo", "logo"],
  components: {
    Tip,
    Login,
  },
  watch:{
    $route:{
      handler(newVal){
        let currentPath = newVal.path === '/' ? '/index' : newVal.path;
        // 精确匹配：当前路径是否等于某个导航项的 URL
        if (this.siteInfo && this.siteInfo.navigation) {
          let matched = this.siteInfo.navigation.find(item => item.url === currentPath);
          if (matched) {
            this.menuIndex = matched.url;
            localStorage.setItem('activeMenuUrl', matched.url);
            return;
          }
        }
        // 无精确匹配：回退到上次点击的导航项（处理详情页等子页面）
        let saved = localStorage.getItem('activeMenuUrl');
        if (saved) {
          this.menuIndex = saved;
        } else {
          this.menuIndex = currentPath;
        }
      },
      immediate:true,
    },
  },
  created() {
    this.getWebsiteInfo();
    if(localStorage.getItem('siteInfo')){
      this.siteCont = JSON.parse(localStorage.getItem('siteInfo'))
    }
  },
  mounted() {
    this.GetUserInfo();
    let names = localStorage.getItem("menuName");
    if (names) {
      // this.menuIndex = names;
    }
    // 通用 token 自动登录
    let urlQuery = this.$route.query;
    // 免登录 autoLogin：只要带 token 就尝试走接口（部分跳转参数只返回 token）
    if (urlQuery.token) {
      // 防止同一个 token 在多个 Header 实例/多次 mounted 时重复触发（导致 loginRecord 发两次）
      const token = urlQuery.token;
      const lockKey = "autoLogin_last_token";
      if (sessionStorage.getItem(lockKey) === token) {
        return;
      }
      sessionStorage.setItem(lockKey, token);

      localStorage.removeItem("auth");
      localStorage.removeItem("user");
      localStorage.removeItem("userInfo");
      this.ClearUserInfo();
      let data = {
        token,
      };
      if (urlQuery.phone) data.phone = urlQuery.phone;
      if (urlQuery.nickname) data.nickname = urlQuery.nickname;
      // 保持停留在首页，避免跳去个人中心
      const targetPath = "/";
      this.$axios.post(`/v1/login/autoLogin`, data).then((res) => {
        if (res.code == 0) {
          localStorage.setItem("auth", JSON.stringify(res.data.auth));
          localStorage.setItem("user", JSON.stringify(res.data.user));
          localStorage.setItem("userInfo", JSON.stringify(res.data.user));
          this.GetUserInfo();
          this.$axios.post(`/v1/px/loginRecord`, {}, { useLog: true });
          this.$router.replace({ path: "/", query: {} }).catch(() => {});
        } else {
          this.ShowTipModal({
            text: res.msg,
          });
        }
      });
    }

    window.addEventListener("scroll", this.handleScroll);
    if(localStorage.getItem('siteInfo')){
      this.siteCont = JSON.parse(localStorage.getItem('siteInfo'))
    }
  },
  computed: {
    ...mapState(["tipModal", "loginModal", "userInfo"]),
  },
  methods: {
    ...mapMutations([
      "ShowLoginModal",
      "CloseLoginModal",
      "GetUserInfo",
      "ClearUserInfo",
      "ShowTipModal",
    ]),
    getWebsiteInfo() {
      this.$axios.post(`/v1/websiteInfo`, { is_pc: 2 }).then((res) => {
        this.siteCont = res.data.site_info;
        localStorage.setItem("nav_zgwt", JSON.stringify(res.data.navigation));
      }) 
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop > 200) {
        this.rightBoxTop = "20%";
      } else {
        this.rightBoxTop = "70%";
      }
    },
    //header登录按钮
    headerLoginBtn() {
      this.ShowLoginModal();
    },
    goNext(data) {
      this.menuIndex = data.url;
      localStorage.setItem('activeMenuUrl', data.url);
      if(data.url.includes('http')){
        window.open(data.url)
        return
      }
      if(data.url=='/userCenter'){
        if(!localStorage.getItem("auth")){
          this.ShowLoginModal()
          return
        }
      }
      let set_info = JSON.parse(localStorage.getItem("siteInfo"));
      document.getElementById("titleName").innerHTML =
        data.name + " - " + set_info.name;
      localStorage.setItem("menuName", data.name);
      let url = data.url.startsWith('/') ? data.url : '/' + data.url;
      this.$router.push(url).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    //退出按钮
    exitBtn() {
      localStorage.removeItem("user");
      localStorage.removeItem("auth");
      localStorage.removeItem("userInfo");
      this.ClearUserInfo();

      if (this.$route.path.includes("userCenter")) {
         localStorage.setItem("menuName", '首页');
         this.menuIndex = '首页'
        this.$router.push("/index");
      } else {
        this.$router.go(0);
      }
    },
    //搜索
    indexSerchBtn() {
      if (!this.indexSerch) {
        return;
      }
      this.$router.push({ 
        path: `/serch/${this.indexSerch}`
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  z-index: 10;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 6px 12px 0px rgba(242, 242, 242, 0.5);
  .content {
    max-width: 1400px;
    height: 120px;
    margin: 0 auto;
    padding: 0px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .left_menu {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .header-logo {
    height: 60px;
    margin-right: 56px;
    flex-shrink: 0;
  }
  .logo_box_bgm {
    width: 295px;
    height: 60px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    margin-right: 56px;
    flex-shrink: 0;
  }
}
.nav {
  display: flex;
  align-items: center;
  li {
    margin-right: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    position: relative;
    a {
      font-size: 20px;
      color: #3e3e3e;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: normal;
      white-space: nowrap;
      line-height: 28px;
    }
    .nav-indicator {
      display: none;
    }
    &.active {
      a {
        font-size: 22px;
        color: #376cec;
        font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
        font-weight: 600;
        line-height: 30px;
      }
      .nav-indicator {
        display: block;
        width: 24px;
        height: 4px;
        background-color: #376cec;
        border-radius: 2px;
        margin-top: 7px;
      }
    }
  }
}
.nav_box_bgm {
  display: flex;
  li {
    width: 80px;
    margin-right: 20px;
    height: 27px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 5px;
  }
}
.right_area {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.serch {
  width: 228px;
  height: 40px;
  background: #ffffff;
  border-radius: 22px;
  border: 1px solid #bfbfbf;
  display: flex;
  align-items: center;
  margin-right: 40px;
  .serch-icon {
    width: 16px;
    height: 16px;
    margin-left: 18px;
    flex-shrink: 0;
  }
  .serch-input {
    flex: 1;
    height: 38px;
    margin-left: 10px;
    margin-right: 10px;
    font-size: 14px;
    color: #333;
    border: none;
    outline: none;
    background: transparent;
    &::placeholder {
      color: #bfbfbf;
      font-size: 14px;
    }
  }
}
.user-state {
  display: flex;
  align-items: center;
  position: relative;
  font-size: 20px;
  .login-btn {
    color: #366cec;
    cursor: pointer;
    white-space: nowrap;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  }
  .login-divider {
    display: inline-block;
    width: 2px;
    height: 17px;
    background-color: #d8d8d8;
    margin: 0 20px;
  }
  .reg-btn {
    color: #333333;
    cursor: pointer;
    white-space: nowrap;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    text-decoration: none;
  }
  .user-head-portrait {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
  }
  .user-name {
    font-size: 16px;
    color: #3e3e3e;
  }
  .user-list {
    position: absolute;
    padding: 20px 16px 0;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.14);
    right: 0;
    top: 100%;
    z-index: 99;
    .option {
      padding-left: 26px;
      height: 26px;
      line-height: 26px;
      font-size: 12px;
      color: #666;
      white-space: nowrap;
      cursor: pointer;
      a {
        font-size: 12px;
        color: #666;
        text-decoration: none;
      }
      &.user-data {
        background: url(~@/assets/user-ico2.png) no-repeat;
        background-size: 24px;
        margin-bottom: 12px;
      }
      &.learning-record {
        background: url(~@/assets/edit-ico.png) no-repeat;
        background-size: 24px;
        margin-bottom: 16px;
      }
      &.exit {
        border-top: 1px solid #e5e5e5;
        background: url(~@/assets/exit-ico.png) no-repeat 0 center;
        background-size: 24px;
        padding-top: 16px;
        padding-bottom: 16px;
      }
    }
  }
}
/* 右侧固定按钮 */
.fixed_right {
  position: fixed;
  top: 70%;
  right: 0%;
  margin-left: 600px;
  transform: translate(-50%, 0%);
  width: 80px;
  padding-bottom: 10px;
  background: #ffffff;
  box-shadow: 0px 4px 7px 1px rgba(20, 6, 5, 0.16);
  border-radius: 6px;
  z-index: 12;
}

.fixed_right ul {
  padding-top: 14px;
}

.fixed_right li p {
  cursor: pointer;
}

.fixed_right li p.img {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.fixed_right li p.img img {
  width: 100%;
  height: 100%;
}

.fixed_right li p.text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #376cec;
  text-align: center;
  margin-top: 15px;
}

li.show_more:hover .show_text {
  display: block;
}

.show_text {
  width: 313px;
  height: 206px;
  background: #ffffff;
  box-shadow: 0px 4px 7px 1px rgba(20, 6, 5, 0.16);
  border-radius: 4px;
  position: absolute;
  right: 95px;
  top: 0;
  z-index: 13;
  display: none;
}

.show_text .title_icon {
  display: flex;
  align-items: center;
  padding: 21px;
}

.show_text .title_icon span {
  font-size: 22px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #376cec;
  margin-left: 10px;
}

.phone_list {
  background: #e5eaef;
  display: flex;
  min-height: 132px;
}
.left_text {
  padding-top: 12px;
  margin-left: 20px;
  .num2 {
    display: flex;
    p {
      cursor: auto;
    }
  }
}
.phone_list p.text1 {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  margin-bottom: 11px;
}
.phone_list div.num {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #376cec;
  margin-bottom: 5px;
}
.phone_list div.num span {
  color: #222;
  margin-right: 10px;
}
.code_img {
  width: 81px;
  height: 81px;
}
.code_img img {
  width: 100%;
  height: 100%;
  margin-left: 22px;
}
</style>
